export default function buildInvoiceItemsQueryString(
  namespace: string,
  queryObject: HashMap<string, string | number | boolean | undefined>,
) {
  return Object.entries(queryObject).reduce(
    (qs: string, [key, val]) => (val ? `${qs}&${namespace}[${key}]=${val}` : qs),
    '',
  );
}
